<template>
    <div class="mx-4 flex-shrink-0 flex w-6 h-6 rounded-full bg-white">
        <ShcUiButton
            data-test="notification__close"
            :theme="BUTTON_THEME.transparent"
            :size="BUTTON_SIZE.none"
            @click="onClose"
        >
            <span class="sr-only">
                {{ $t('Bbk.notification.close') }}
            </span>
            <div aria-hidden="true">
                <ShcUiIcon name="close" />
            </div>
        </ShcUiButton>
    </div>
</template>

<script setup lang="ts">
    import { BUTTON_SIZE, BUTTON_THEME } from '@shc/nuxt-shc-ui-layer/components/Button/button'
    import { NOTIFICATION_EVENT } from '~/components/Shc/Ui/Notification/notification'
    import type { Props } from '~/components/Shc/Ui/Notification/Close/props'

    const props = defineProps<Props>()

    const emit = defineEmits<{
        (e: typeof NOTIFICATION_EVENT.notification_close, show: boolean): void
    }>()
    const timeout = ref<NodeJS.Timeout>()

    if (props.show && props.autoClose) {
        timeout.value = setTimeout(() => {
            emit(NOTIFICATION_EVENT.notification_close, false)
        }, 5000)
    }

    function onClose() {
        emit(NOTIFICATION_EVENT.notification_close, false)
    }

    onBeforeUnmount(() => {
        clearTimeout(timeout.value)
    })
</script>
